import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { GroupMasterForm } from "@univdiam/ui/customComponents/GroupMasterList/GroupMasterForm";
import axios from "axios";

const API_BASE_URL = import.meta.env.VITE_SERVER_URL;

interface GroupData {
  id: string;
  name: string;
  status: string;
}

export default function EditGroupMaster() {
  const { id } = useParams();
  const navigate = useNavigate();
  const [groupData, setGroupData] = useState<GroupData[]>([]);
  const [subGroupData, setSubGroupData] = useState<GroupData[]>([]);
  const [subSubGroupData, setSubSubGroupData] = useState<GroupData[]>([]);
  const [initialData, setInitialData] = useState<any>(null);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const [groupRes, subGroupRes, subSubGroupRes, initialRes] = await Promise.all([
          axios.get(`${API_BASE_URL}/api/groups`),
          axios.get(`${API_BASE_URL}/api/sub_groups`),
          axios.get(`${API_BASE_URL}/api/sub_sub_groups`),
          axios.get(`${API_BASE_URL}/api/group_masters/${id}`)
        ]);

        setGroupData(groupRes.data.data.map((g: any) => ({
          id: g.group_id,
          name: g.name,
          status: g.status === 1 ? "Enabled" : "Disabled"
        })));

        setSubGroupData(subGroupRes.data.data.map((g: any) => ({
          id: g.sub_group_id,
          name: g.name,
          status: g.status === 1 ? "Enabled" : "Disabled"
        })));

        setSubSubGroupData(subSubGroupRes.data.data.map((g: any) => ({
          id: g.sub_sub_group_id,
          name: g.name,
          status: g.status === 1 ? "Enabled" : "Disabled"
        })));

        const group = initialRes.data.data;
        setInitialData({
          group: group.group_id,
          subGroup: group.sub_group_id,
          subSubGroup: group.sub_sub_group_id,
          name: group.name,
          code: group.code || "",
          uom: group.uom || "",
          bom: String(group.bom || 0),
          status: String(group.status || "1")
        });
      } catch (err) {
        console.error("Failed to fetch data", err);
        navigate("/group_masters");
      }
    };

    fetchData();
  }, [id, navigate]);

  const handleUpdateGroupMaster = async (data: any) => {
    try {
      const response = await axios.put(`${API_BASE_URL}/api/group_masters/${id}`, data);
      if (response.status === 200) {
        alert("Group master updated successfully!");
        navigate("/group_masters");
      }
    } catch (error) {
      console.error("Error updating group:", error);
      alert("Failed to update group.");
    }
  };

  const handleGroupChange = async (groupId: string) => {
    try {
      const response = await axios.get(`${API_BASE_URL}/api/group_masters/sub_groups/${groupId}`);
      return response.data.data.map((item: any) => ({
        id: item.sub_group_id,
        name: item.name,
        status: item.status === 1 ? "Enabled" : "Disabled"
      }));
    } catch (error) {
      console.error("Failed to fetch sub groups:", error);
      return [];
    }
  };

  const handleSubGroupChange = async (subGroupId: string) => {
    try {
      const response = await axios.get(`${API_BASE_URL}/api/group_masters/sub_sub_groups/${subGroupId}`);
      return response.data.data.map((item: any) => ({
        id: item.sub_sub_group_id,
        name: item.name,
        status: item.status === 1 ? "Enabled" : "Disabled"
      }));
    } catch (error) {
      console.error("Failed to fetch sub sub groups:", error);
      return [];
    }
  };

  if (!initialData) return <p className="text-center p-10">Loading...</p>;

  return (
    <div className="p-6 max-w-2xl mx-auto">
      <h1 className="text-2xl font-bold mb-6">Edit Group Master</h1>
      <GroupMasterForm 
        onSubmit={handleUpdateGroupMaster}
        initialValues={initialData}
        groupValues={groupData}
        subGroupValues={subGroupData}
        subSubGroupValues={subSubGroupData}
        fetchSubGroups={handleGroupChange}
        fetchSubSubGroups={handleSubGroupChange}
        isEdit
      />
    </div>
  );
}